var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83331 5.5L8.17025 9.09056C10.5064 10.4143 11.4935 10.4143 13.8297 9.09056L20.1666 5.5",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84776 12.3527C1.90769 15.1628 1.93766 16.5678 2.97452 17.6086C4.01139 18.6494 5.45445 18.6857 8.34057 18.7582C10.1193 18.8029 11.8806 18.8029 13.6594 18.7582C16.5455 18.6857 17.9886 18.6494 19.0254 17.6086C20.0623 16.5678 20.0923 15.1628 20.1522 12.3527C20.1715 11.4492 20.1715 10.5509 20.1522 9.6474C20.0923 6.83733 20.0623 5.43229 19.0254 4.39148C17.9886 3.35067 16.5455 3.31441 13.6594 3.2419C11.8806 3.1972 10.1193 3.1972 8.34057 3.24189C5.45445 3.3144 4.01139 3.35065 2.97452 4.39147C1.93765 5.43228 1.90769 6.83732 1.84776 9.64739C1.8285 10.5509 1.8285 11.4491 1.84776 12.3527Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail01);
export default __webpack_public_path__ + "static/media/mail-01.a35b66a89735f3baf1177a89564ddaf3.svg";
export { ForwardRef as ReactComponent };